<template>
    <svg :fill="color" :width="width" :height="height" viewBox="0 0 32 32" version="1.1"
         xmlns="http://www.w3.org/2000/svg">
<!--        <title>soccer-ball</title>-->
        <path
            d="M23.726 3.8c-6.809-4.33-15.821-2.347-20.129 4.428-0.001 0.002-0.002 0.004-0.004 0.006-4.308 6.775-2.281 15.777 4.528 20.106s15.821 2.347 20.129-4.428c0.001-0.002 0.002-0.004 0.004-0.006 4.308-6.775 2.281-15.777-4.528-20.106zM10.047 22.687l-4.812 0.763-2.477-6.306 2.989-3.666 4.401 2.885-0.101 6.325zM14.343 2.222v0l-1.929 3.035-5.677 2.833-1.665-1.289c1.235-2.126 5.846-4.435 6.72-4.345 1.194-0.596 2.6-0.311 2.552-0.234zM24.582 24.965l-3.449 3.889-5.706 0.687-0.515-3.697 5.686-3.005 3.984 2.126zM20.776 17.222l-5.371-3.172 1.22-6.272 5.958 0.021 2.869 5.676-4.675 3.746zM25.685 5.931l-2.090-0.555-2.33-2.254c0-0 4.073 1.89 4.42 2.809v0zM28.371 21.489v0l0.317-5.628 1.022-1.919c0.415 0.264 0.351 6.211-0.854 8.063-0.799 0.48-0.484-0.516-0.484-0.516z"></path>
    </svg>
</template>
<style scoped>
</style>
<script>
export default {
    name: 'app-soccer-ball',
    props: {
        color: {
            default: 'black',
            type: String,
        },
        size: {
            default: 24,
            type: Number,
        },
    },
    mounted() {
        console.log('Component %s mounted.', this.$options.name);
    },
    data() {
        return {

        };
    },
    methods: {},
    computed: {
        width() {
            return this.$props.size + 'px';
        },

        height() {
            return this.$props.size + 'px';
        }
    },
};

</script>
